/**
 * @generated SignedSource<<103a61759979cf5700cd23e55024fb91>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbSharedRefineMenuFilterItemType_itemSearch$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedRefineMenuRadioSelectList_itemSearch">;
  readonly " $fragmentType": "SbSharedRefineMenuFilterItemType_itemSearch";
};
export type SbSharedRefineMenuFilterItemType_itemSearch$key = {
  readonly " $data"?: SbSharedRefineMenuFilterItemType_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedRefineMenuFilterItemType_itemSearch">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedRefineMenuFilterItemType_itemSearch",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuRadioSelectList_itemSearch"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};

(node as any).hash = "a2775814b44c41ccb21661998e7c392e";

export default node;
